export const event_special = {
  onboarding_landing_page: 'onboarding_landing_page',
  login: 'login',
};

export const event_special_params = {};
